module.exports = __webpack_public_path__ + "img/image-icon.959362c3.svg";